import { OSS_CONSTANT, OSSCdnUrl } from '@/config/config'
const OSS_ACCELERATE_URL = `https://${OSS_CONSTANT.Bucket}.${OSS_CONSTANT.Region}.aliyuncs.com/`
const OSS_ACCELERATE_URL_HTTP = `http://${OSS_CONSTANT.Bucket}.${OSS_CONSTANT.Region}.aliyuncs.com/`
const OSS_DOWNLOAD_ROOT_URL = OSS_CONSTANT.DownloadRootUrl
const OSS_DOWNLOAD_ROOT_URL_HTTP = OSS_CONSTANT.DownloadRootUrl.replace(
  'https',
  'http'
)
// 설정된 버킷의 알리바바 OSS 주소 전부(가속 · 리전 엔드포인트, http · https).
//   2026-09 이관 뒤 `OSS_DOWNLOAD_ROOT_URL` 을 CDN 주소로 바꾸면 위 두 값만으로는
//   DB 에 남은 `…oss-cn-beijing…` 주소를 알아보지 못합니다. 설정값과 무관하게
//   옛 OSS 주소를 CDN 으로 바꾸도록 고정 패턴을 둡니다.
//   버킷 이름은 소문자 · 숫자 · 하이픈만 쓰므로(OSS 규칙) 이스케이프하지 않습니다.
const OSS_HOST_PATTERN = `https?://${OSS_CONSTANT.Bucket}[.]oss-[a-z0-9-]+[.]aliyuncs[.]com/`
export class OssResourceUtils {
  private matchRegex = new RegExp(
    `${OSS_HOST_PATTERN}|${OSS_ACCELERATE_URL}|${OSS_ACCELERATE_URL_HTTP}|${OSS_DOWNLOAD_ROOT_URL}|${OSS_DOWNLOAD_ROOT_URL_HTTP}`
  )

  constructor(private url: string) {}

  getNormalizedUrl() {
    return (this.url as string).replace(this.matchRegex, OSSCdnUrl)
  }

  static getAccelerateUrl() {
    return OSS_ACCELERATE_URL
  }

  static getOssHostPattern() {
    return OSS_HOST_PATTERN
  }

  static getDownloadRootUrl() {
    return OSS_CONSTANT.DownloadRootUrl
  }

  static getCdnUrl() {
    return OSSCdnUrl
  }
}
